import type { MediaPlan } from '@mint-sdk/api-media-plan';

const DEFAULT_SIDEBAR_PRIORITY = 5;

export const SHOW_PLANNING_SIDEBAR = DEFAULT_SIDEBAR_PRIORITY + 1;
export const HIDE_PLANNING_SIDEBAR = DEFAULT_SIDEBAR_PRIORITY - 1;

export const levelIcons = {
  media_plan: 'Table',
  activity: 'Activity',
  flight: 'Calendar',
} as const;

export const EMPTY_SIDEBAR_TREE: MediaPlan.SidebarItem = {
  mediaDataId: '',
  level: '',
  name: '',
  subItems: [],
};
